// extracted by mini-css-extract-plugin
export default {"container":"_6B0gUEpOge2RjoiUYn8mAw"};